export default __webpack_public_path__ + "5a23b0b550958200b2c11a943b0a1a55.svg";